<template>
<q-page class="main">
  <common-form :action="$route('user.update', { gebruiker: user.id})" is-update>
    <q-card class="page-card">
      <q-card-section class="page-card__main-content">
        <div class="row items-center justify-between q-mb-lg">
          <h1 class="heading-2 q-mb-lg">{{ $fullName(user) }}</h1>
          <flat-button label="Contactgegevens" icon="call" @click="$refs.detailsModal.show()" />
        </div>
        <common-banner v-if="!user.activated" class="q-mb-lg">
          Deze gebruiker heeft zijn of haar account nog niet geactiveerd. Stuur de
          uitnodiging opnieuw:
          <template v-slot:actions>
            <q-btn color="primary" text-color="white" unelevated no-caps @click="resendInvite">
              Verstuur uitnodiging
            </q-btn>
          </template>
        </common-banner>
        <user-form :user="user" :roles="roles" :categories="categories" :roleIds="roleIds" />
      </q-card-section>
      <q-separator />
      <q-card-actions class="q-pa-md" align="between">
        <warning-button v-if="!user.deleted_at" label="Verwijder account" @click="deleteUser" />
        <flat-button v-if="mfaEnabled" label="Deactiveer multifactor" @click="disableMFA" />
        <accent-button label="Opslaan" type="submit" />
      </q-card-actions>
    </q-card>
    <sticky-top-bar />
  </common-form>

  <user-contact-details
      ref="detailsModal"
      :userId="user.id"
  />
</q-page>
</template>

<script>
import UserForm from './UserForm'
import UserContactDetails from './dialog/UserContact'

export default {
  components: {
    UserForm,
    UserContactDetails,
  },
  data() {
    return {
      mfaEnabled: this.user.two_factor_confirmed_at,
    }
  },
  props: {
    user: {
      type: Object,
    },
    roles: {
      type: Array,
      default: () => [],
    },
    roleIds: {
      type: Array,
      default: () => [],
    },
    categories: {
      type: Array,
      default: () => [],
    },
    userCategories: {
      type: Object,
      default: () => [],
    },
  },
  methods: {
    resendInvite() {
      this.$goto('user.resend-invitation', { user: this.user.id })
    },
    async disableMFA() {
      if (!this.mfaEnabled || !await this.$confirm(
          {
            title: 'Mutlifactor login deactiveren',
            messages: [
              `Weet u zeker dat u de multifactor login van gebruiker ${this.$fullName(this.user)} wilt deactiveren?
                Dit verlaagt de veiligheid van de account van deze gebruiker`,
            ],
          },
      )) {
        return
      }
      await axios.delete(this.$route('user.disable-mfa', { user: this.user.id }))
      this.$toast('success', 'Multifactor login is uitgeschakeld.')
      this.mfaEnabled = false
    },
    async deleteUser() {
      if (!await this.$confirm(
          {
            title: 'Gebruiker verwijderen',
            messages: [`Weet u zeker dat u de gebruiker ${this.$fullName(this.user)} wilt verwijderen?
            Er kan dan niet meer worden ingelogd vanaf dit e-mailadres. Dit kan niet worden teruggedraaid.`],
          },
      )) {
        return
      }
      await axios.delete(this.$route('user.destroy', { user: this.user.id }))
      this.$toast('success', 'De gebruiker is verwijderd.')
      this.$goto('user.index')
    },
  },
}
</script>
